module.exports = __webpack_public_path__ + "static/media/transfer-PENDING_TOKEN.77b7be5d.svg";